import React, { useState } from "react";
import { format, getMonth, getYear } from "date-fns";
import '../styles/CalendarSelector.css';
import axios from "axios";
import { useEffect } from "react";


const toLocalDateString = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const CalendarSelector = ({ selectedDate, setSelectedDate, selectedTime, setSelectedTime, setStep }) => {
  const [busyDates, setBusyDates] = useState([]);
  const startDate = new Date(); // Don't mutate this reference
  // Removed unused variable 'allDays'

  const months = [
    "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
    "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
  ];

  const [selectedMonth, setSelectedMonth] = useState(getMonth(startDate));
  const [selectedYear, setSelectedYear] = useState(getYear(startDate));

  const daysInMonth = Array.from({ length: 31 }, (_, i) => {
    const date = new Date(selectedYear, selectedMonth, i + 1);
    return date.getMonth() === selectedMonth ? date : null;
  }).filter(Boolean);

  useEffect(() => {
    const fetchBlockedDatesAndSlots = async () => {
      try {
        const start = new Date(selectedYear, selectedMonth, 1).toISOString().split("T")[0];
        const end = new Date(selectedYear, selectedMonth + 1, 0).toISOString().split("T")[0];

        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/calendar/day-and-slot-blocks`, {
          params: { start, end },
        });

        const blocked = response.data?.blockedDays || [];
        const fullyBooked = response.data?.fullyBookedDays || [];
        const alsoFullyBooked = response.data?.fullyBookedDates || [];
        console.log("Busy Dates:", [...blocked, ...fullyBooked, ...alsoFullyBooked]);
        setBusyDates([...blocked, ...fullyBooked, ...alsoFullyBooked]);
      } catch (error) {
        console.error("Error fetching blocked days", error);
      }
    };
    fetchBlockedDatesAndSlots();
  }, [selectedMonth, selectedYear]);

  const monthStart = new Date(selectedYear, selectedMonth, 1);
  const startDay = monthStart.getDay(); // Sunday = 0, Monday = 1, ...
  const offset = (startDay + 6) % 7; // shift so Monday = 0


  const leadingEmptyDays = Array(offset).fill(null);
  const filteredDays = [...leadingEmptyDays, ...daysInMonth];

  console.log("Rendering CalendarSelector");
  return (
    <div className="flex flex-col items-center justify-center w-full px-4">
      {/* Calendar Section */}
      <div className="w-full max-w-[700px] calendar-container">
        

        <div className="flex items-center gap-4 mb-4 px-4">
          <div className="text-lg font-semibold">{`${months[selectedMonth]} ${selectedYear}`}</div>
          <div className="flex gap-1 ml-auto text-sm">
            <button
              onClick={() => {
                if (selectedMonth === 0) {
                  setSelectedMonth(11);
                  setSelectedYear(selectedYear - 1);
                } else {
                  setSelectedMonth(selectedMonth - 1);
                }
              }}
              className="text-xl font-light px-1"
            >
              &lt;
            </button>
            <button
              onClick={() => {
                if (selectedMonth === 11) {
                  setSelectedMonth(0);
                  setSelectedYear(selectedYear + 1);
                } else {
                  setSelectedMonth(selectedMonth + 1);
                }
              }}
              className="text-xl font-light px-1"
            >
              &gt;
            </button>
          </div>
        </div>

        <div className="calendar-grid-container pt-4 pb-4 bg-gray-50 rounded-xl shadow-sm" style={{ paddingLeft: "12px", paddingRight: "12px" }}>
          <div className="grid grid-cols-7 text-sm mb-2 px-2 gap-[2px]">
            {["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"].map((d) => (
              <div key={d} className="text-gray-500 font-medium w-10 justify-start flex">{d}</div>
            ))}
          </div>
          <div className="grid grid-cols-7 gap-[2px] text-sm px-2">
            {filteredDays.map((day, index) => {
              if (!day) {
                return <div key={index} className="w-10 h-10"></div>; // empty cell
              }
              const isSelected = selectedDate && new Date(selectedDate).toDateString() === day.toDateString();
              const dayOfWeek = day.getDay();
              const isPast = day < new Date().setHours(0, 0, 0, 0) || dayOfWeek === 0 || dayOfWeek === 6;
              const formattedDay = format(day, 'yyyy-MM-dd');
              const isBusy = busyDates.includes(formattedDay);

              if (isBusy) {
                return (
                  <div
                    key={day.toDateString()}
                    className="w-8 h-8 flex items-center justify-center text-gray-400 bg-gray-100 rounded cursor-not-allowed text-sm font-medium"
                    title="Giorno non disponibile"
                  >
                    {format(day, "d")}
                  </div>
                );
              }
              return (
                <div
                  key={day.toDateString()}
                  onClick={() => {
                    if (!isPast) {
                      setSelectedDate(toLocalDateString(day));
                      setSelectedTime(null);
                      setTimeout(() => {
                        if (typeof setStep === 'function') {
                          setStep(2);
                        }
                      }, 150);
                    }
                  }}
                  className={`cursor-pointer w-8 h-8 flex items-center justify-center text-sm font-medium transition-all duration-200 ${
                    isSelected
                      ? "bg-[#304653] text-white rounded-full"
                      : isPast
                      ? "text-gray-400 cursor-not-allowed"
                      : "text-gray-900 hover:bg-gray-100"
                  }`}
                >
                  {format(day, "d")}
                </div>
              );
            })}
          </div>
        </div>
      </div>

    </div>
  );
};

export default CalendarSelector;